const doc = [({"label":"Trouver une commune:", "placeholder":"Nom de la commune"})];
module.exports = doc.length <= 1 ? doc[0] : doc;